import type { CompanyReviewsAISummary, Jobs } from '@seek/libs-shared';
import type { CompanyDetails } from '../../../shared/services/companyDetailsService/types';
import type { CompaniesListModel } from '../../models/companiesListModel';
import { mockedSalaryRanges } from './mockedSalaryRanges';
import type { SalariesTabModel } from './salariesTabModel';

export const mapSalariesModel = (
  companyId: string,
  companyDetails: CompanyDetails,
  jobs: Jobs,
  randomCompaniesInThisIndustry: CompaniesListModel,
): SalariesTabModel => ({
  companyName: companyDetails.companyProfile?.data?.name ?? '',
  // Map the salary satisfaction rating - same logic with review summary
  salarySatisfactionRating: (() => {
    const percentage1 =
      companyDetails.companyProfile?.companyReviewRating?.salaryFair
        ?.percentage ?? 0;
    const percentage2 =
      companyDetails.companyProfile?.companyReviewRating?.salaryGenerous
        ?.percentage ?? 0;
    const rating = percentage1 + percentage2;
    return rating > 0 ? rating : undefined;
  })(),
  jobs: {
    jobs: jobs.jobs,
    totalJobs: jobs.totalJobs,
    companyName: companyDetails.companyProfile?.data?.name ?? '',
    organisationId: companyDetails.companyProfile?.organisationId ?? undefined,
    companyId,
  },
  companyReviewsAISummary:
    (companyDetails.companyReviewsAISummary as CompanyReviewsAISummary) ??
    undefined,
  salaryRanges: mockedSalaryRanges,
  randomCompaniesInThisIndustry,
});
